/*
 * @Author: your name
 * @Date: 2020-10-13 08:32:27
 * @LastEditTime: 2020-11-02 10:24:08
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: \writing_pc\static\js\http.js
 */ 
import axios from "axios" ;
import { Message } from 'element-ui';
import stateType from './state';
import router from '../../src/router/index';
axios.defaults.timeout = 10000 ;  //响应时间

var Url={
    // url:'http://test-write-pc.bigan.net/',
    // url: 'http://testwrite.ixueshu.com/lb-write-service/',
    url: 'http://localhost:8027/',
    biganUrl:'http://testwww.bigan.net/'
} 
// 环境的切换 
if (process.env.NODE_ENV == 'development') {
    // axios.defaults.baseURL = 'http://test-write-pc.bigan.net/'
    axios.defaults.baseURL = 'http://localhost:8027/'
} else if (process.env.NODE_ENV == 'production') {
    Url={
        url:'http://write.ixueshu.com/lb-write-service/',
        biganUrl:'https://www.bigan.net/'
    }
    //测试环境
    axios.defaults.baseURL = Url.url;
} else if (process.env.NODE_ENV == 'production-test') {
    Url={
        url:'http://testwrite.ixueshu.com/lb-write-service/',
        biganUrl:'http://testwww.bigan.net/'
    }
    //测试环境
    axios.defaults.baseURL = Url.url;

};

let token = "";
//POST传参序列化(添加请求拦截器)
axios.interceptors.request.use(function(config) {
    //在发送请求之前做某件事  
    token = localStorage.getItem('token') || ""  //获取token 
    if (token != "") {
        stateType.isLogin=true
        config.headers = {
            'token': token,
            'Content-Type': 'application/json',
            'device-no': new Date().getTime()
        }
    }
    if (config.type=='upfile') {
        config.headers = {
            'token': token,
            'Content-Type': 'multipart/form-data',
            'device-no': new Date().getTime()
        }
    }
    if(config.type=='code'){
        config.baseURL=Url.biganUrl 
    }else{
        config.baseURL=Url.url 
    }
    return config;
}, function(error)  {
    console.log('错误的传参')
    return Promise.reject(error);
});
//返回状态判断(添加响应拦截器)
axios.interceptors.response.use(function(res) {
    //对响应数据做些事    
    if (res.data.code == '401') {    //如果token 过期 则跳转到登录页面 
        stateType.isLogin=false
        router.replace({
            path: '/login',
            query: {
                redirect: router.currentRoute.fullPath
            }
        });
    }
    if (res.data.code == -1 && res.config.url != "write-api/api/check/detail") {
        Message({
            message: res.data.msg,
            type: 'error',
            center: true,
            duration: 1000
        });
    }

    return res;
}, function(error)  { 
  stateType.aiAbstract = false 
  if(!error.response){
    Message({
        message: '当前网络状况不佳',
        type: 'warning',
        center: true,
        duration: 1000
    });
    let res = {
        code: 0,
        data:[]
    }
    return Promise.reject(res);
  }
    if (error.response.status == 404) {
        let res = {
            code: 404
        }
        return Promise.reject(res);
    }  
});
//返回一个Promise(发送post请求)
function post(url, params) {
    return new Promise(function(resolve, reject)  {
        axios.post(url, params)
            .then(function(response) {
                resolve(response.data);
            }, function(err) {
                reject(err);
            })
            .catch(function(error) {
                reject(error)
            })
    })
};
////返回一个Promise(发送get请求)
function get(url, param) {

    return new Promise(function(resolve, reject)  {
        axios.get(url, { params: param })
            .then(function(response) {
                resolve(response.data)
            }, function(err) {

                console.log(err)
                if (err.code == 404) {
                    resolve(err)
                } else {
                    reject(err)
                }
            })
            .catch(function(error) {
                reject(error)
            })
    })
};
/**
 * 上传文件
 */
function upfile(url, param) {
    axios.defaults.type = 'upfile' 
    return new Promise(function(resolve, reject) {
        axios.post(url, param)
            .then(function(response) {
                resolve(response.data)
            }, function(err) {
                reject(err)
            })
            .catch(function(error) {
                reject(error)
            })
        axios.defaults.type = undefined
    })
};
function getcode(url,params) {
    axios.defaults.type = 'code'
    return new Promise(function(resolve, reject)  {
        axios.get(url, { params: params })
            .then(function(response) {
                resolve(response.data)
            }, function(err) {

                console.log(err)
                if (err.code == 404) {
                    resolve(err)
                } else {
                    reject(err)
                }
            })
            .catch(function(error) {
                reject(error)
            })
            axios.defaults.type = undefined
    })
}
function dow(url, param) {
    window.open(axios.defaults.baseURL + url + '?token=' + token, '_blank').location;
};
export default {
    get,
    post,
    dow,
    upfile,
    getcode
}



// WEBPACK FOOTER //
// ./static/js/http.js